import { IRecentSearchTile } from '../../../utilities/types';
import ReturnVisitorRecentSearchesCarousel from '../../../../../components/carousels/home-base-hero-carousel/ReturnVisitorRecentSearchesCarousel';
import { SearchedPlaceholderCarousel } from '../../../../../components/carousels/home-base-hero-carousel/SearchedPlaceholderCarousel';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

interface ISearchedCarouselProps {
    isVisible: boolean;
    recentSearchesList: IRecentSearchTile[];
    isLoadingSearchedTab: boolean;
    hasLoadedSearchedTab: boolean;
    leftAligned: boolean;
}

const SearchedCarousel = ({
    isVisible,
    recentSearchesList,
    isLoadingSearchedTab,
    hasLoadedSearchedTab,
    leftAligned,
}: ISearchedCarouselProps) => {
    if (hasLoadedSearchedTab && recentSearchesList.length > 0) {
        // Without the min-height, the carousel overflows the container and it does not match the design
        return (
            <Box sx={{ minHeight: 326 }}>
                <ReturnVisitorRecentSearchesCarousel
                    carouselName="searched"
                    analyticsName="Searched"
                    isVisible={isVisible}
                    recentSearchTileList={recentSearchesList}
                    ariaLabel="Recent Vehicle Searches"
                    leftAligned={leftAligned}
                />
            </Box>
        );
    } else if (isLoadingSearchedTab) {
        // This basically never shows up since recent searches load in the background on home base now,
        // but leaving it in just in case.
        return (
            <Box sx={{ minHeight: 326 }}>
                <Stack alignItems="center" justifyContent="center" sx={{ minHeight: 320 }}>
                    <CircularProgress color="secondary" size={64} />
                </Stack>
            </Box>
        );
    } else if (hasLoadedSearchedTab && recentSearchesList.length === 0) {
        return <SearchedPlaceholderCarousel />;
    }

    return null;
};

export default SearchedCarousel;
